module.exports = __webpack_public_path__ + "img/copy.c56550e.svg";